module.exports = __webpack_public_path__ + "assets/img/yzm-container-back2.d4cb3d5c.png";